@file:OptIn(org.jetbrains.compose.resources.InternalResourceApi::class)

package busmanagementsystem.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.StringResource

private object CommonMainString0 {
  public val add: StringResource by 
      lazy { init_add() }

  public val available: StringResource by 
      lazy { init_available() }

  public val back_to_home: StringResource by 
      lazy { init_back_to_home() }

  public val button_add_stop: StringResource by 
      lazy { init_button_add_stop() }

  public val button_customize_seat_layout: StringResource by 
      lazy { init_button_customize_seat_layout() }

  public val button_next_steps: StringResource by 
      lazy { init_button_next_steps() }

  public val coach_category_ac: StringResource by 
      lazy { init_coach_category_ac() }

  public val coach_category_non_ac: StringResource by 
      lazy { init_coach_category_non_ac() }

  public val coach_type_seater: StringResource by 
      lazy { init_coach_type_seater() }

  public val coach_type_sleeper: StringResource by 
      lazy { init_coach_type_sleeper() }

  public val confirm_password: StringResource by 
      lazy { init_confirm_password() }

  public val content_desc_add: StringResource by 
      lazy { init_content_desc_add() }

  public val content_desc_check: StringResource by 
      lazy { init_content_desc_check() }

  public val content_desc_date: StringResource by 
      lazy { init_content_desc_date() }

  public val content_desc_decrease: StringResource by 
      lazy { init_content_desc_decrease() }

  public val content_desc_increase: StringResource by 
      lazy { init_content_desc_increase() }

  public val content_desc_location: StringResource by 
      lazy { init_content_desc_location() }

  public val content_desc_logo: StringResource by 
      lazy { init_content_desc_logo() }

  public val content_desc_payment: StringResource by 
      lazy { init_content_desc_payment() }

  public val content_desc_remove: StringResource by 
      lazy { init_content_desc_remove() }

  public val content_desc_time: StringResource by 
      lazy { init_content_desc_time() }

  public val create_new_account: StringResource by 
      lazy { init_create_new_account() }

  public val create_new_trip_subtitle: StringResource by 
      lazy { init_create_new_trip_subtitle() }

  public val create_new_trip_title: StringResource by 
      lazy { init_create_new_trip_title() }

  public val create_trip: StringResource by 
      lazy { init_create_trip() }

  public val create_trip_description: StringResource by 
      lazy { init_create_trip_description() }

  public val delete: StringResource by 
      lazy { init_delete() }

  public val delete_trip_confirmation: StringResource by 
      lazy { init_delete_trip_confirmation() }

  public val dialog_action_lock_seat: StringResource by 
      lazy { init_dialog_action_lock_seat() }

  public val dialog_action_unlock_seat: StringResource by 
      lazy { init_dialog_action_unlock_seat() }

  public val email: StringResource by 
      lazy { init_email() }

  public val enter_invitation_code: StringResource by 
      lazy { init_enter_invitation_code() }

  public val enter_phone_number: StringResource by 
      lazy { init_enter_phone_number() }

  public val enter_trip_code: StringResource by 
      lazy { init_enter_trip_code() }

  public val error: StringResource by 
      lazy { init_error() }

  public val forgot_password: StringResource by 
      lazy { init_forgot_password() }

  public val get_ticket: StringResource by 
      lazy { init_get_ticket() }

  public val get_ticket_description: StringResource by 
      lazy { init_get_ticket_description() }

  public val headline: StringResource by 
      lazy { init_headline() }

  public val hint_add_stops: StringResource by 
      lazy { init_hint_add_stops() }

  public val home_page_title: StringResource by 
      lazy { init_home_page_title() }

  public val join_a_trip: StringResource by 
      lazy { init_join_a_trip() }

  public val join_trip: StringResource by 
      lazy { init_join_trip() }

  public val join_trip_desc: StringResource by 
      lazy { init_join_trip_desc() }

  public val label_arrival_date: StringResource by 
      lazy { init_label_arrival_date() }

  public val label_arrival_time: StringResource by 
      lazy { init_label_arrival_time() }

  public val label_back_row: StringResource by 
      lazy { init_label_back_row() }

  public val label_coach_category: StringResource by 
      lazy { init_label_coach_category() }

  public val label_coach_type: StringResource by 
      lazy { init_label_coach_type() }

  public val label_cost_per_seat: StringResource by 
      lazy { init_label_cost_per_seat() }

  public val label_departure_date: StringResource by 
      lazy { init_label_departure_date() }

  public val label_departure_time: StringResource by 
      lazy { init_label_departure_time() }

  public val label_email_id: StringResource by 
      lazy { init_label_email_id() }

  public val label_from: StringResource by 
      lazy { init_label_from() }

  public val label_left_row: StringResource by 
      lazy { init_label_left_row() }

  public val label_organizer_name: StringResource by 
      lazy { init_label_organizer_name() }

  public val label_phone_number: StringResource by 
      lazy { init_label_phone_number() }

  public val label_price: StringResource by 
      lazy { init_label_price() }

  public val label_right_row: StringResource by 
      lazy { init_label_right_row() }

  public val label_stop_number: StringResource by 
      lazy { init_label_stop_number() }

  public val label_to: StringResource by 
      lazy { init_label_to() }

  public val label_total_seats: StringResource by 
      lazy { init_label_total_seats() }

  public val label_trip_title: StringResource by 
      lazy { init_label_trip_title() }

  public val login_account_title: StringResource by 
      lazy { init_login_account_title() }

  public val name: StringResource by 
      lazy { init_name() }

  public val no: StringResource by 
      lazy { init_no() }

  public val no_trips_description: StringResource by 
      lazy { init_no_trips_description() }

  public val ok: StringResource by 
      lazy { init_ok() }

  public val passenger_list: StringResource by 
      lazy { init_passenger_list() }

  public val password: StringResource by 
      lazy { init_password() }

  public val phone_number: StringResource by 
      lazy { init_phone_number() }

  public val placeholder_arrival_location: StringResource by 
      lazy { init_placeholder_arrival_location() }

  public val placeholder_departure_location: StringResource by 
      lazy { init_placeholder_departure_location() }

  public val prompt_customize_seat_layout: StringResource by 
      lazy { init_prompt_customize_seat_layout() }

  public val remove: StringResource by 
      lazy { init_remove() }

  public val reserve_seat: StringResource by 
      lazy { init_reserve_seat() }

  public val reserve_seat_description: StringResource by 
      lazy { init_reserve_seat_description() }

  public val reserved: StringResource by 
      lazy { init_reserved() }

  public val seat_layout: StringResource by 
      lazy { init_seat_layout() }

  public val seat_variable: StringResource by 
      lazy { init_seat_variable() }

  public val share_code: StringResource by 
      lazy { init_share_code() }

  public val share_code_description: StringResource by 
      lazy { init_share_code_description() }

  public val sign_up: StringResource by 
      lazy { init_sign_up() }

  public val sign_up_description: StringResource by 
      lazy { init_sign_up_description() }

  public val sign_up_title: StringResource by 
      lazy { init_sign_up_title() }

  public val subheadline: StringResource by 
      lazy { init_subheadline() }

  public val submit_trip: StringResource by 
      lazy { init_submit_trip() }

  public val support_text_email_id: StringResource by 
      lazy { init_support_text_email_id() }

  public val support_text_phone_number: StringResource by 
      lazy { init_support_text_phone_number() }

  public val tab_lower_deck: StringResource by 
      lazy { init_tab_lower_deck() }

  public val tab_upper_deck: StringResource by 
      lazy { init_tab_upper_deck() }

  public val text_price_per_seat: StringResource by 
      lazy { init_text_price_per_seat() }

  public val ticket_details: StringResource by 
      lazy { init_ticket_details() }

  public val total: StringResource by 
      lazy { init_total() }

  public val validation_field_arrival_date: StringResource by 
      lazy { init_validation_field_arrival_date() }

  public val validation_field_arrival_location: StringResource by 
      lazy { init_validation_field_arrival_location() }

  public val validation_field_arrival_time: StringResource by 
      lazy { init_validation_field_arrival_time() }

  public val validation_field_coach_category: StringResource by 
      lazy { init_validation_field_coach_category() }

  public val validation_field_coach_type: StringResource by 
      lazy { init_validation_field_coach_type() }

  public val validation_field_cost_per_seat: StringResource by 
      lazy { init_validation_field_cost_per_seat() }

  public val validation_field_departure_date: StringResource by 
      lazy { init_validation_field_departure_date() }

  public val validation_field_departure_location: StringResource by 
      lazy { init_validation_field_departure_location() }

  public val validation_field_departure_time: StringResource by 
      lazy { init_validation_field_departure_time() }

  public val validation_field_organizer_email: StringResource by 
      lazy { init_validation_field_organizer_email() }

  public val validation_field_organizer_name: StringResource by 
      lazy { init_validation_field_organizer_name() }

  public val validation_field_organizer_phone: StringResource by 
      lazy { init_validation_field_organizer_phone() }

  public val validation_field_total_seats: StringResource by 
      lazy { init_validation_field_total_seats() }

  public val validation_field_trip_title: StringResource by 
      lazy { init_validation_field_trip_title() }

  public val view: StringResource by 
      lazy { init_view() }

  public val yes: StringResource by 
      lazy { init_yes() }

  public val your_trips: StringResource by 
      lazy { init_your_trips() }
}

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("add", CommonMainString0.add)
  map.put("available", CommonMainString0.available)
  map.put("back_to_home", CommonMainString0.back_to_home)
  map.put("button_add_stop", CommonMainString0.button_add_stop)
  map.put("button_customize_seat_layout", CommonMainString0.button_customize_seat_layout)
  map.put("button_next_steps", CommonMainString0.button_next_steps)
  map.put("coach_category_ac", CommonMainString0.coach_category_ac)
  map.put("coach_category_non_ac", CommonMainString0.coach_category_non_ac)
  map.put("coach_type_seater", CommonMainString0.coach_type_seater)
  map.put("coach_type_sleeper", CommonMainString0.coach_type_sleeper)
  map.put("confirm_password", CommonMainString0.confirm_password)
  map.put("content_desc_add", CommonMainString0.content_desc_add)
  map.put("content_desc_check", CommonMainString0.content_desc_check)
  map.put("content_desc_date", CommonMainString0.content_desc_date)
  map.put("content_desc_decrease", CommonMainString0.content_desc_decrease)
  map.put("content_desc_increase", CommonMainString0.content_desc_increase)
  map.put("content_desc_location", CommonMainString0.content_desc_location)
  map.put("content_desc_logo", CommonMainString0.content_desc_logo)
  map.put("content_desc_payment", CommonMainString0.content_desc_payment)
  map.put("content_desc_remove", CommonMainString0.content_desc_remove)
  map.put("content_desc_time", CommonMainString0.content_desc_time)
  map.put("create_new_account", CommonMainString0.create_new_account)
  map.put("create_new_trip_subtitle", CommonMainString0.create_new_trip_subtitle)
  map.put("create_new_trip_title", CommonMainString0.create_new_trip_title)
  map.put("create_trip", CommonMainString0.create_trip)
  map.put("create_trip_description", CommonMainString0.create_trip_description)
  map.put("delete", CommonMainString0.delete)
  map.put("delete_trip_confirmation", CommonMainString0.delete_trip_confirmation)
  map.put("dialog_action_lock_seat", CommonMainString0.dialog_action_lock_seat)
  map.put("dialog_action_unlock_seat", CommonMainString0.dialog_action_unlock_seat)
  map.put("email", CommonMainString0.email)
  map.put("enter_invitation_code", CommonMainString0.enter_invitation_code)
  map.put("enter_phone_number", CommonMainString0.enter_phone_number)
  map.put("enter_trip_code", CommonMainString0.enter_trip_code)
  map.put("error", CommonMainString0.error)
  map.put("forgot_password", CommonMainString0.forgot_password)
  map.put("get_ticket", CommonMainString0.get_ticket)
  map.put("get_ticket_description", CommonMainString0.get_ticket_description)
  map.put("headline", CommonMainString0.headline)
  map.put("hint_add_stops", CommonMainString0.hint_add_stops)
  map.put("home_page_title", CommonMainString0.home_page_title)
  map.put("join_a_trip", CommonMainString0.join_a_trip)
  map.put("join_trip", CommonMainString0.join_trip)
  map.put("join_trip_desc", CommonMainString0.join_trip_desc)
  map.put("label_arrival_date", CommonMainString0.label_arrival_date)
  map.put("label_arrival_time", CommonMainString0.label_arrival_time)
  map.put("label_back_row", CommonMainString0.label_back_row)
  map.put("label_coach_category", CommonMainString0.label_coach_category)
  map.put("label_coach_type", CommonMainString0.label_coach_type)
  map.put("label_cost_per_seat", CommonMainString0.label_cost_per_seat)
  map.put("label_departure_date", CommonMainString0.label_departure_date)
  map.put("label_departure_time", CommonMainString0.label_departure_time)
  map.put("label_email_id", CommonMainString0.label_email_id)
  map.put("label_from", CommonMainString0.label_from)
  map.put("label_left_row", CommonMainString0.label_left_row)
  map.put("label_organizer_name", CommonMainString0.label_organizer_name)
  map.put("label_phone_number", CommonMainString0.label_phone_number)
  map.put("label_price", CommonMainString0.label_price)
  map.put("label_right_row", CommonMainString0.label_right_row)
  map.put("label_stop_number", CommonMainString0.label_stop_number)
  map.put("label_to", CommonMainString0.label_to)
  map.put("label_total_seats", CommonMainString0.label_total_seats)
  map.put("label_trip_title", CommonMainString0.label_trip_title)
  map.put("login_account_title", CommonMainString0.login_account_title)
  map.put("name", CommonMainString0.name)
  map.put("no", CommonMainString0.no)
  map.put("no_trips_description", CommonMainString0.no_trips_description)
  map.put("ok", CommonMainString0.ok)
  map.put("passenger_list", CommonMainString0.passenger_list)
  map.put("password", CommonMainString0.password)
  map.put("phone_number", CommonMainString0.phone_number)
  map.put("placeholder_arrival_location", CommonMainString0.placeholder_arrival_location)
  map.put("placeholder_departure_location", CommonMainString0.placeholder_departure_location)
  map.put("prompt_customize_seat_layout", CommonMainString0.prompt_customize_seat_layout)
  map.put("remove", CommonMainString0.remove)
  map.put("reserve_seat", CommonMainString0.reserve_seat)
  map.put("reserve_seat_description", CommonMainString0.reserve_seat_description)
  map.put("reserved", CommonMainString0.reserved)
  map.put("seat_layout", CommonMainString0.seat_layout)
  map.put("seat_variable", CommonMainString0.seat_variable)
  map.put("share_code", CommonMainString0.share_code)
  map.put("share_code_description", CommonMainString0.share_code_description)
  map.put("sign_up", CommonMainString0.sign_up)
  map.put("sign_up_description", CommonMainString0.sign_up_description)
  map.put("sign_up_title", CommonMainString0.sign_up_title)
  map.put("subheadline", CommonMainString0.subheadline)
  map.put("submit_trip", CommonMainString0.submit_trip)
  map.put("support_text_email_id", CommonMainString0.support_text_email_id)
  map.put("support_text_phone_number", CommonMainString0.support_text_phone_number)
  map.put("tab_lower_deck", CommonMainString0.tab_lower_deck)
  map.put("tab_upper_deck", CommonMainString0.tab_upper_deck)
  map.put("text_price_per_seat", CommonMainString0.text_price_per_seat)
  map.put("ticket_details", CommonMainString0.ticket_details)
  map.put("total", CommonMainString0.total)
  map.put("validation_field_arrival_date", CommonMainString0.validation_field_arrival_date)
  map.put("validation_field_arrival_location", CommonMainString0.validation_field_arrival_location)
  map.put("validation_field_arrival_time", CommonMainString0.validation_field_arrival_time)
  map.put("validation_field_coach_category", CommonMainString0.validation_field_coach_category)
  map.put("validation_field_coach_type", CommonMainString0.validation_field_coach_type)
  map.put("validation_field_cost_per_seat", CommonMainString0.validation_field_cost_per_seat)
  map.put("validation_field_departure_date", CommonMainString0.validation_field_departure_date)
  map.put("validation_field_departure_location",
      CommonMainString0.validation_field_departure_location)
  map.put("validation_field_departure_time", CommonMainString0.validation_field_departure_time)
  map.put("validation_field_organizer_email", CommonMainString0.validation_field_organizer_email)
  map.put("validation_field_organizer_name", CommonMainString0.validation_field_organizer_name)
  map.put("validation_field_organizer_phone", CommonMainString0.validation_field_organizer_phone)
  map.put("validation_field_total_seats", CommonMainString0.validation_field_total_seats)
  map.put("validation_field_trip_title", CommonMainString0.validation_field_trip_title)
  map.put("view", CommonMainString0.view)
  map.put("yes", CommonMainString0.yes)
  map.put("your_trips", CommonMainString0.your_trips)
}

internal val Res.string.add: StringResource
  get() = CommonMainString0.add

private fun init_add(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:add", "add",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    10, 23),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    10, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    10, 35),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    10, 15),
    )
)

internal val Res.string.available: StringResource
  get() = CommonMainString0.available

private fun init_available(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:available", "available",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    26, 29),
    )
)

internal val Res.string.back_to_home: StringResource
  get() = CommonMainString0.back_to_home

private fun init_back_to_home(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:back_to_home", "back_to_home",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    34, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    42, 72),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    46, 76),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    56, 36),
    )
)

internal val Res.string.button_add_stop: StringResource
  get() = CommonMainString0.button_add_stop

private fun init_button_add_stop(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:button_add_stop", "button_add_stop",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    79, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    115, 67),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    123, 71),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    93, 35),
    )
)

internal val Res.string.button_customize_seat_layout: StringResource
  get() = CommonMainString0.button_customize_seat_layout

private fun init_button_customize_seat_layout(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:button_customize_seat_layout", "button_customize_seat_layout",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    123, 104),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    183, 128),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    195, 132),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    129, 72),
    )
)

internal val Res.string.button_next_steps: StringResource
  get() = CommonMainString0.button_next_steps

private fun init_button_next_steps(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:button_next_steps", "button_next_steps",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    228, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    312, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    328, 57),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    202, 41),
    )
)

internal val Res.string.coach_category_ac: StringResource
  get() = CommonMainString0.coach_category_ac

private fun init_coach_category_ac(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:coach_category_ac", "coach_category_ac",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    278, 29),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    382, 29),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    386, 37),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    244, 29),
    )
)

internal val Res.string.coach_category_non_ac: StringResource
  get() = CommonMainString0.coach_category_non_ac

private fun init_coach_category_non_ac(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:coach_category_non_ac", "coach_category_non_ac",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    308, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    412, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    424, 57),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    274, 37),
    )
)

internal val Res.string.coach_type_seater: StringResource
  get() = CommonMainString0.coach_type_seater

private fun init_coach_type_seater(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:coach_type_seater", "coach_type_seater",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    346, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    450, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    482, 41),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    312, 33),
    )
)

internal val Res.string.coach_type_sleeper: StringResource
  get() = CommonMainString0.coach_type_sleeper

private fun init_coach_type_sleeper(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:coach_type_sleeper", "coach_type_sleeper",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    384, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    492, 50),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    524, 50),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    346, 38),
    )
)

internal val Res.string.confirm_password: StringResource
  get() = CommonMainString0.confirm_password

private fun init_confirm_password(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:confirm_password", "confirm_password",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    419, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    543, 100),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    575, 104),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    385, 48),
    )
)

internal val Res.string.content_desc_add: StringResource
  get() = CommonMainString0.content_desc_add

private fun init_content_desc_add(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:content_desc_add", "content_desc_add",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    472, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    644, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    680, 48),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    434, 28),
    )
)

internal val Res.string.content_desc_check: StringResource
  get() = CommonMainString0.content_desc_check

private fun init_content_desc_check(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:content_desc_check", "content_desc_check",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    509, 38),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    689, 66),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    729, 70),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    463, 38),
    )
)

internal val Res.string.content_desc_date: StringResource
  get() = CommonMainString0.content_desc_date

private fun init_content_desc_date(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:content_desc_date", "content_desc_date",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    548, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    756, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    800, 41),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    502, 33),
    )
)

internal val Res.string.content_desc_decrease: StringResource
  get() = CommonMainString0.content_desc_decrease

private fun init_content_desc_decrease(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:content_desc_decrease", "content_desc_decrease",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    582, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    802, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    842, 49),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    536, 41),
    )
)

internal val Res.string.content_desc_increase: StringResource
  get() = CommonMainString0.content_desc_increase

private fun init_content_desc_increase(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:content_desc_increase", "content_desc_increase",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    624, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    852, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    892, 53),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    578, 41),
    )
)

internal val Res.string.content_desc_location: StringResource
  get() = CommonMainString0.content_desc_location

private fun init_content_desc_location(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:content_desc_location", "content_desc_location",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    666, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    902, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    946, 49),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    620, 41),
    )
)

internal val Res.string.content_desc_logo: StringResource
  get() = CommonMainString0.content_desc_logo

private fun init_content_desc_logo(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:content_desc_logo", "content_desc_logo",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    712, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    948, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    996, 53),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    662, 37),
    )
)

internal val Res.string.content_desc_payment: StringResource
  get() = CommonMainString0.content_desc_payment

private fun init_content_desc_payment(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:content_desc_payment", "content_desc_payment",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    770, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    1002, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    1050, 52),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    700, 40),
    )
)

internal val Res.string.content_desc_remove: StringResource
  get() = CommonMainString0.content_desc_remove

private fun init_content_desc_remove(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:content_desc_remove", "content_desc_remove",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    807, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    1055, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    1103, 47),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    741, 35),
    )
)

internal val Res.string.content_desc_time: StringResource
  get() = CommonMainString0.content_desc_time

private fun init_content_desc_time(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:content_desc_time", "content_desc_time",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    847, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    1111, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    1151, 37),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    777, 33),
    )
)

internal val Res.string.create_new_account: StringResource
  get() = CommonMainString0.create_new_account

private fun init_create_new_account(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:create_new_account", "create_new_account",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    881, 58),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    1149, 94),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    1189, 78),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    811, 54),
    )
)

internal val Res.string.create_new_trip_subtitle: StringResource
  get() = CommonMainString0.create_new_trip_subtitle

private fun init_create_new_trip_subtitle(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:create_new_trip_subtitle", "create_new_trip_subtitle",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    940, 92),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    1244, 152),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    1268, 164),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    866, 76),
    )
)

internal val Res.string.create_new_trip_title: StringResource
  get() = CommonMainString0.create_new_trip_title

private fun init_create_new_trip_title(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:create_new_trip_title", "create_new_trip_title",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    1033, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    1397, 85),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    1433, 93),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    943, 53),
    )
)

internal val Res.string.create_trip: StringResource
  get() = CommonMainString0.create_trip

private fun init_create_trip(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:create_trip", "create_trip",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    1259, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    1751, 63),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    1815, 67),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    1133, 39),
    )
)

internal val Res.string.create_trip_description: StringResource
  get() = CommonMainString0.create_trip_description

private fun init_create_trip_description(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:create_trip_description", "create_trip_description",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    1091, 167),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    1483, 267),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    1527, 287),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    997, 135),
    )
)

internal val Res.string.delete: StringResource
  get() = CommonMainString0.delete

private fun init_delete(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:delete", "delete",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    1270, 22),
    )
)

internal val Res.string.delete_trip_confirmation: StringResource
  get() = CommonMainString0.delete_trip_confirmation

private fun init_delete_trip_confirmation(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:delete_trip_confirmation", "delete_trip_confirmation",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    1173, 96),
    )
)

internal val Res.string.dialog_action_lock_seat: StringResource
  get() = CommonMainString0.dialog_action_lock_seat

private fun init_dialog_action_lock_seat(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:dialog_action_lock_seat", "dialog_action_lock_seat",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    1299, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    1815, 71),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    1883, 75),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    1293, 43),
    )
)

internal val Res.string.dialog_action_unlock_seat: StringResource
  get() = CommonMainString0.dialog_action_unlock_seat

private fun init_dialog_action_unlock_seat(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:dialog_action_unlock_seat", "dialog_action_unlock_seat",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    1355, 61),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    1887, 81),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    1959, 85),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    1337, 49),
    )
)

internal val Res.string.email: StringResource
  get() = CommonMainString0.email

private fun init_email(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:email", "email",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    1417, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    1969, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    2045, 29),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    1387, 21),
    )
)

internal val Res.string.enter_invitation_code: StringResource
  get() = CommonMainString0.enter_invitation_code

private fun init_enter_invitation_code(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:enter_invitation_code", "enter_invitation_code",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    1459, 73),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    2003, 101),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    2075, 105),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    1409, 57),
    )
)

internal val Res.string.enter_phone_number: StringResource
  get() = CommonMainString0.enter_phone_number

private fun init_enter_phone_number(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:enter_phone_number", "enter_phone_number",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    1467, 58),
    )
)

internal val Res.string.enter_trip_code: StringResource
  get() = CommonMainString0.enter_trip_code

private fun init_enter_trip_code(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:enter_trip_code", "enter_trip_code",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    1526, 43),
    )
)

internal val Res.string.error: StringResource
  get() = CommonMainString0.error

private fun init_error(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:error", "error",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    1533, 21),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    2105, 25),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    2181, 37),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    1570, 21),
    )
)

internal val Res.string.forgot_password: StringResource
  get() = CommonMainString0.forgot_password

private fun init_forgot_password(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:forgot_password", "forgot_password",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    1555, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    2131, 95),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    2219, 75),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    1592, 47),
    )
)

internal val Res.string.get_ticket: StringResource
  get() = CommonMainString0.get_ticket

private fun init_get_ticket(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:get_ticket", "get_ticket",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    1774, 42),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    2518, 82),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    2610, 98),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    1759, 38),
    )
)

internal val Res.string.get_ticket_description: StringResource
  get() = CommonMainString0.get_ticket_description

private fun init_get_ticket_description(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:get_ticket_description", "get_ticket_description",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    1615, 158),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    2227, 290),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    2295, 314),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    1640, 118),
    )
)

internal val Res.string.headline: StringResource
  get() = CommonMainString0.headline

private fun init_headline(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:headline", "headline",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    1817, 104),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    2601, 144),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    2709, 136),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    1798, 76),
    )
)

internal val Res.string.hint_add_stops: StringResource
  get() = CommonMainString0.hint_add_stops

private fun init_hint_add_stops(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:hint_add_stops", "hint_add_stops",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    1922, 94),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    2746, 210),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    2846, 222),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    1875, 94),
    )
)

internal val Res.string.home_page_title: StringResource
  get() = CommonMainString0.home_page_title

private fun init_home_page_title(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:home_page_title", "home_page_title",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    2017, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    2957, 103),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    3069, 91),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    1970, 39),
    )
)

internal val Res.string.join_a_trip: StringResource
  get() = CommonMainString0.join_a_trip

private fun init_join_a_trip(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:join_a_trip", "join_a_trip",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    2010, 35),
    )
)

internal val Res.string.join_trip: StringResource
  get() = CommonMainString0.join_trip

private fun init_join_trip(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:join_trip", "join_trip",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    2129, 29),
    )
)

internal val Res.string.join_trip_desc: StringResource
  get() = CommonMainString0.join_trip_desc

private fun init_join_trip_desc(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:join_trip_desc", "join_trip_desc",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    2046, 82),
    )
)

internal val Res.string.label_arrival_date: StringResource
  get() = CommonMainString0.label_arrival_date

private fun init_label_arrival_date(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:label_arrival_date", "label_arrival_date",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    2061, 50),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    3061, 66),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    3161, 62),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    2159, 42),
    )
)

internal val Res.string.label_arrival_time: StringResource
  get() = CommonMainString0.label_arrival_time

private fun init_label_arrival_time(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:label_arrival_time", "label_arrival_time",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    2112, 46),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    3128, 58),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    3224, 58),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    2202, 42),
    )
)

internal val Res.string.label_back_row: StringResource
  get() = CommonMainString0.label_back_row

private fun init_label_back_row(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:label_back_row", "label_back_row",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    2159, 38),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    3187, 66),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    3283, 70),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    2245, 34),
    )
)

internal val Res.string.label_coach_category: StringResource
  get() = CommonMainString0.label_coach_category

private fun init_label_coach_category(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:label_coach_category", "label_coach_category",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    2198, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    3254, 72),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    3354, 68),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    2280, 48),
    )
)

internal val Res.string.label_coach_type: StringResource
  get() = CommonMainString0.label_coach_type

private fun init_label_coach_type(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:label_coach_type", "label_coach_type",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    2259, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    3327, 72),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    3423, 72),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    2329, 40),
    )
)

internal val Res.string.label_cost_per_seat: StringResource
  get() = CommonMainString0.label_cost_per_seat

private fun init_label_cost_per_seat(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:label_cost_per_seat", "label_cost_per_seat",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    2308, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    3400, 83),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    3496, 79),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    2370, 47),
    )
)

internal val Res.string.label_departure_date: StringResource
  get() = CommonMainString0.label_departure_date

private fun init_label_departure_date(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:label_departure_date", "label_departure_date",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    2360, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    3484, 84),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    3576, 80),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    2418, 48),
    )
)

internal val Res.string.label_departure_time: StringResource
  get() = CommonMainString0.label_departure_time

private fun init_label_departure_time(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:label_departure_time", "label_departure_time",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    2409, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    3569, 76),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    3657, 76),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    2467, 48),
    )
)

internal val Res.string.label_email_id: StringResource
  get() = CommonMainString0.label_email_id

private fun init_label_email_id(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:label_email_id", "label_email_id",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    2458, 50),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    3646, 62),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    3734, 58),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    2516, 34),
    )
)

internal val Res.string.label_from: StringResource
  get() = CommonMainString0.label_from

private fun init_label_from(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:label_from", "label_from",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    2509, 26),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    3709, 26),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    3793, 26),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    2551, 26),
    )
)

internal val Res.string.label_left_row: StringResource
  get() = CommonMainString0.label_left_row

private fun init_label_left_row(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:label_left_row", "label_left_row",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    2536, 42),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    3736, 58),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    3820, 66),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    2578, 34),
    )
)

internal val Res.string.label_organizer_name: StringResource
  get() = CommonMainString0.label_organizer_name

private fun init_label_organizer_name(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:label_organizer_name", "label_organizer_name",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    2579, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    3795, 76),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    3887, 72),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    2613, 48),
    )
)

internal val Res.string.label_phone_number: StringResource
  get() = CommonMainString0.label_phone_number

private fun init_label_phone_number(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:label_phone_number", "label_phone_number",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    2640, 54),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    3872, 58),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    3960, 62),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    2662, 42),
    )
)

internal val Res.string.label_price: StringResource
  get() = CommonMainString0.label_price

private fun init_label_price(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:label_price", "label_price",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    2695, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    3931, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    4023, 39),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    2705, 27),
    )
)

internal val Res.string.label_right_row: StringResource
  get() = CommonMainString0.label_right_row

private fun init_label_right_row(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:label_right_row", "label_right_row",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    2723, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    3971, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    4063, 67),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    2733, 35),
    )
)

internal val Res.string.label_stop_number: StringResource
  get() = CommonMainString0.label_stop_number

private fun init_label_stop_number(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:label_stop_number", "label_stop_number",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    2763, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    4031, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    4131, 53),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    2769, 37),
    )
)

internal val Res.string.label_to: StringResource
  get() = CommonMainString0.label_to

private fun init_label_to(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:label_to", "label_to",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    2855, 24),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    4143, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    4247, 24),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    2849, 20),
    )
)

internal val Res.string.label_total_seats: StringResource
  get() = CommonMainString0.label_total_seats

private fun init_label_total_seats(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:label_total_seats", "label_total_seats",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    2805, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    4085, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    4185, 61),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    2807, 41),
    )
)

internal val Res.string.label_trip_title: StringResource
  get() = CommonMainString0.label_trip_title

private fun init_label_trip_title(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:label_trip_title", "label_trip_title",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    2880, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    4176, 84),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    4272, 84),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    2870, 40),
    )
)

internal val Res.string.login_account_title: StringResource
  get() = CommonMainString0.login_account_title

private fun init_login_account_title(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:login_account_title", "login_account_title",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    2929, 75),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    4261, 127),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    4357, 123),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    2911, 63),
    )
)

internal val Res.string.name: StringResource
  get() = CommonMainString0.name

private fun init_name(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:name", "name",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    3005, 20),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    4389, 24),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    4481, 24),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    2975, 20),
    )
)

internal val Res.string.no: StringResource
  get() = CommonMainString0.no

private fun init_no(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:no", "no",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    3065, 14),
    )
)

internal val Res.string.no_trips_description: StringResource
  get() = CommonMainString0.no_trips_description

private fun init_no_trips_description(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:no_trips_description", "no_trips_description",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    3026, 72),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    4414, 116),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    4506, 132),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    2996, 68),
    )
)

internal val Res.string.ok: StringResource
  get() = CommonMainString0.ok

private fun init_ok(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:ok", "ok",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    3099, 22),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    4531, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    4639, 34),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    3080, 14),
    )
)

internal val Res.string.passenger_list: StringResource
  get() = CommonMainString0.passenger_list

private fun init_passenger_list(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:passenger_list", "passenger_list",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    3095, 42),
    )
)

internal val Res.string.password: StringResource
  get() = CommonMainString0.password

private fun init_password(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:password", "password",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    3122, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    4566, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    4674, 44),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    3138, 28),
    )
)

internal val Res.string.phone_number: StringResource
  get() = CommonMainString0.phone_number

private fun init_phone_number(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:phone_number", "phone_number",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    3155, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    4611, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    4719, 56),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    3167, 36),
    )
)

internal val Res.string.placeholder_arrival_location: StringResource
  get() = CommonMainString0.placeholder_arrival_location

private fun init_placeholder_arrival_location(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:placeholder_arrival_location", "placeholder_arrival_location",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    3204, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    4664, 72),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    4776, 76),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    3204, 60),
    )
)

internal val Res.string.placeholder_departure_location: StringResource
  get() = CommonMainString0.placeholder_departure_location

private fun init_placeholder_departure_location(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:placeholder_departure_location", "placeholder_departure_location",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    3265, 58),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    4737, 90),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    4853, 94),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    3265, 62),
    )
)

internal val Res.string.prompt_customize_seat_layout: StringResource
  get() = CommonMainString0.prompt_customize_seat_layout

private fun init_prompt_customize_seat_layout(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:prompt_customize_seat_layout", "prompt_customize_seat_layout",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    3324, 108),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    4828, 168),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    4948, 184),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    3328, 92),
    )
)

internal val Res.string.remove: StringResource
  get() = CommonMainString0.remove

private fun init_remove(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:remove", "remove",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    3433, 26),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    4997, 42),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    5133, 34),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    3421, 22),
    )
)

internal val Res.string.reserve_seat: StringResource
  get() = CommonMainString0.reserve_seat

private fun init_reserve_seat(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:reserve_seat", "reserve_seat",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    3577, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    5293, 72),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    5433, 80),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    3549, 36),
    )
)

internal val Res.string.reserve_seat_description: StringResource
  get() = CommonMainString0.reserve_seat_description

private fun init_reserve_seat_description(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:reserve_seat_description", "reserve_seat_description",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    3460, 116),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    5040, 252),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    5168, 264),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    3444, 104),
    )
)

internal val Res.string.reserved: StringResource
  get() = CommonMainString0.reserved

private fun init_reserved(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:reserved", "reserved",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    3586, 28),
    )
)

internal val Res.string.seat_layout: StringResource
  get() = CommonMainString0.seat_layout

private fun init_seat_layout(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:seat_layout", "seat_layout",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    3615, 35),
    )
)

internal val Res.string.seat_variable: StringResource
  get() = CommonMainString0.seat_variable

private fun init_seat_variable(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:seat_variable", "seat_variable",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    3651, 37),
    )
)

internal val Res.string.share_code: StringResource
  get() = CommonMainString0.share_code

private fun init_share_code(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:share_code", "share_code",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    3733, 46),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    5557, 58),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    5733, 66),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    3792, 38),
    )
)

internal val Res.string.share_code_description: StringResource
  get() = CommonMainString0.share_code_description

private fun init_share_code_description(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:share_code_description", "share_code_description",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    3622, 110),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    5366, 190),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    5514, 218),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    3689, 102),
    )
)

internal val Res.string.sign_up: StringResource
  get() = CommonMainString0.sign_up

private fun init_sign_up(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:sign_up", "sign_up",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    3982, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    6050, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    6214, 59),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    4005, 27),
    )
)

internal val Res.string.sign_up_description: StringResource
  get() = CommonMainString0.sign_up_description

private fun init_sign_up_description(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:sign_up_description", "sign_up_description",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    3780, 139),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    5616, 307),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    5800, 299),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    3831, 119),
    )
)

internal val Res.string.sign_up_title: StringResource
  get() = CommonMainString0.sign_up_title

private fun init_sign_up_title(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:sign_up_title", "sign_up_title",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    3920, 61),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    5924, 125),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    6100, 113),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    3951, 53),
    )
)

internal val Res.string.subheadline: StringResource
  get() = CommonMainString0.subheadline

private fun init_subheadline(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:subheadline", "subheadline",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    4014, 111),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    6106, 207),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    6274, 219),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    4033, 95),
    )
)

internal val Res.string.submit_trip: StringResource
  get() = CommonMainString0.submit_trip

private fun init_submit_trip(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:submit_trip", "submit_trip",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    4126, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    6314, 75),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    6494, 83),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    4129, 35),
    )
)

internal val Res.string.support_text_email_id: StringResource
  get() = CommonMainString0.support_text_email_id

private fun init_support_text_email_id(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:support_text_email_id", "support_text_email_id",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    4162, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    6390, 109),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    6578, 125),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    4165, 57),
    )
)

internal val Res.string.support_text_phone_number: StringResource
  get() = CommonMainString0.support_text_phone_number

private fun init_support_text_phone_number(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:support_text_phone_number", "support_text_phone_number",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    4220, 77),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    6500, 125),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    6704, 129),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    4223, 69),
    )
)

internal val Res.string.tab_lower_deck: StringResource
  get() = CommonMainString0.tab_lower_deck

private fun init_tab_lower_deck(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:tab_lower_deck", "tab_lower_deck",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    4298, 42),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    6626, 58),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    6834, 58),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    4293, 38),
    )
)

internal val Res.string.tab_upper_deck: StringResource
  get() = CommonMainString0.tab_upper_deck

private fun init_tab_upper_deck(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:tab_upper_deck", "tab_upper_deck",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    4341, 42),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    6685, 54),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    6893, 54),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    4332, 38),
    )
)

internal val Res.string.text_price_per_seat: StringResource
  get() = CommonMainString0.text_price_per_seat

private fun init_text_price_per_seat(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:text_price_per_seat", "text_price_per_seat",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    4384, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    6740, 71),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    6948, 71),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    4371, 47),
    )
)

internal val Res.string.ticket_details: StringResource
  get() = CommonMainString0.ticket_details

private fun init_ticket_details(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:ticket_details", "ticket_details",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    4419, 42),
    )
)

internal val Res.string.total: StringResource
  get() = CommonMainString0.total

private fun init_total(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:total", "total",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    4462, 21),
    )
)

internal val Res.string.validation_field_arrival_date: StringResource
  get() = CommonMainString0.validation_field_arrival_date

private fun init_validation_field_arrival_date(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:validation_field_arrival_date", "validation_field_arrival_date",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    4436, 61),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    6812, 77),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    7020, 73),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    4484, 53),
    )
)

internal val Res.string.validation_field_arrival_location: StringResource
  get() = CommonMainString0.validation_field_arrival_location

private fun init_validation_field_arrival_location(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:validation_field_arrival_location", "validation_field_arrival_location",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    4498, 65),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    6890, 77),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    7094, 81),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    4538, 65),
    )
)

internal val Res.string.validation_field_arrival_time: StringResource
  get() = CommonMainString0.validation_field_arrival_time

private fun init_validation_field_arrival_time(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:validation_field_arrival_time", "validation_field_arrival_time",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    4564, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    6968, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    7176, 69),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    4604, 53),
    )
)

internal val Res.string.validation_field_coach_category: StringResource
  get() = CommonMainString0.validation_field_coach_category

private fun init_validation_field_coach_category(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:validation_field_coach_category", "validation_field_coach_category",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    4622, 71),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    7038, 83),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    7246, 79),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    4658, 59),
    )
)

internal val Res.string.validation_field_coach_type: StringResource
  get() = CommonMainString0.validation_field_coach_type

private fun init_validation_field_coach_type(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:validation_field_coach_type", "validation_field_coach_type",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    4694, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    7122, 83),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    7326, 83),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    4718, 51),
    )
)

internal val Res.string.validation_field_cost_per_seat: StringResource
  get() = CommonMainString0.validation_field_cost_per_seat

private fun init_validation_field_cost_per_seat(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:validation_field_cost_per_seat", "validation_field_cost_per_seat",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    4754, 62),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    7206, 94),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    7410, 90),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    4770, 58),
    )
)

internal val Res.string.validation_field_departure_date: StringResource
  get() = CommonMainString0.validation_field_departure_date

private fun init_validation_field_departure_date(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:validation_field_departure_date", "validation_field_departure_date",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    4817, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    7301, 95),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    7501, 91),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    4829, 59),
    )
)

internal val Res.string.validation_field_departure_location: StringResource
  get() = CommonMainString0.validation_field_departure_location

private fun init_validation_field_departure_location(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:validation_field_departure_location", "validation_field_departure_location",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    4877, 63),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    7397, 95),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    7593, 99),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    4889, 67),
    )
)

internal val Res.string.validation_field_departure_time: StringResource
  get() = CommonMainString0.validation_field_departure_time

private fun init_validation_field_departure_time(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:validation_field_departure_time", "validation_field_departure_time",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    4941, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    7493, 87),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    7693, 87),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    4957, 59),
    )
)

internal val Res.string.validation_field_organizer_email: StringResource
  get() = CommonMainString0.validation_field_organizer_email

private fun init_validation_field_organizer_email(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:validation_field_organizer_email", "validation_field_organizer_email",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    5001, 88),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    7581, 108),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    7781, 104),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    5017, 64),
    )
)

internal val Res.string.validation_field_organizer_name: StringResource
  get() = CommonMainString0.validation_field_organizer_name

private fun init_validation_field_organizer_name(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:validation_field_organizer_name", "validation_field_organizer_name",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    5090, 71),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    7690, 87),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    7886, 83),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    5082, 59),
    )
)

internal val Res.string.validation_field_organizer_phone: StringResource
  get() = CommonMainString0.validation_field_organizer_phone

private fun init_validation_field_organizer_phone(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:validation_field_organizer_phone", "validation_field_organizer_phone",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    5162, 88),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    7778, 100),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    7970, 104),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    5142, 72),
    )
)

internal val Res.string.validation_field_total_seats: StringResource
  get() = CommonMainString0.validation_field_total_seats

private fun init_validation_field_total_seats(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:validation_field_total_seats", "validation_field_total_seats",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    5251, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    7879, 68),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    8075, 72),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    5215, 52),
    )
)

internal val Res.string.validation_field_trip_title: StringResource
  get() = CommonMainString0.validation_field_trip_title

private fun init_validation_field_trip_title(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:validation_field_trip_title", "validation_field_trip_title",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    5312, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    7948, 95),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    8148, 95),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    5268, 51),
    )
)

internal val Res.string.view: StringResource
  get() = CommonMainString0.view

private fun init_view(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:view", "view",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    5320, 20),
    )
)

internal val Res.string.yes: StringResource
  get() = CommonMainString0.yes

private fun init_yes(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:yes", "yes",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    5341, 15),
    )
)

internal val Res.string.your_trips: StringResource
  get() = CommonMainString0.your_trips

private fun init_your_trips(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:your_trips", "your_trips",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-es/string.commonMain.cvr",
    5372, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("gu"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-gu/string.commonMain.cvr",
    8044, 70),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values-hi/string.commonMain.cvr",
    8244, 70),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/busmanagementsystem.composeapp.generated.resources/values/string.commonMain.cvr",
    5357, 34),
    )
)
